// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"509":"a88afa00","631":"7b139413"}[chunkId] + ".chunk.js";
};